"use client";

import { c as _c } from "react/compiler-runtime";
import { Loader2 } from "lucide-react";
import type React from "react";
import { useCallback, useState } from "react";
import { Button } from "@defuse/ui/button";
import { Input } from "@defuse/ui/input";
import { submitDepositTx } from "@/lib/one-click-api";
interface SubmitDepositTxFormProps {
  depositAddress: string;
}
export function SubmitDepositTxForm(t0) {
  const $ = _c(24);
  const {
    depositAddress
  } = t0;
  const [txHash, setTxHash] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState(null);
  let t1;
  if ($[0] !== depositAddress || $[1] !== isSubmitting || $[2] !== txHash) {
    t1 = async e => {
      e.preventDefault();
      if (isSubmitting) {
        return;
      }
      if (txHash.trim() === "") {
        setMessage({
          type: "error",
          text: "Please enter a transaction hash"
        });
        return;
      }
      setIsSubmitting(true);
      setMessage(null);
      const result = await submitDepositTx(depositAddress, txHash.trim());
      setIsSubmitting(false);
      if (result.success) {
        setMessage({
          type: "success",
          text: "Transaction submitted successfully!"
        });
        setTxHash("");
      } else {
        setMessage({
          type: "error",
          text: result.error !== "" && result.error !== undefined ? result.error : "Failed to submit transaction"
        });
      }
    };
    $[0] = depositAddress;
    $[1] = isSubmitting;
    $[2] = txHash;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSubmit = t1;
  let t2;
  if ($[4] !== handleSubmit) {
    t2 = e_0 => {
      handleSubmit(e_0);
    };
    $[4] = handleSubmit;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="text-muted-foreground text-xs">Speed up processing by submitting your deposit transaction hash:</div>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e_1 => {
      setTxHash(e_1.target.value);
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isSubmitting || $[9] !== txHash) {
    t5 = <Input type="text" placeholder="Enter transaction hash" value={txHash} onChange={t4} disabled={isSubmitting} className="h-9" />;
    $[8] = isSubmitting;
    $[9] = txHash;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isSubmitting) {
    t6 = isSubmitting ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />Submitting</> : "Submit";
    $[11] = isSubmitting;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <Button type="submit" size="sm" className="h-9">{t6}</Button>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t7) {
    t8 = <div className="flex flex-col gap-2 sm:flex-row">{t5}{t7}</div>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== message) {
    t9 = message !== null && <div className={`text-xs ${message.type === "success" ? "text-green-600 dark:text-green-400" : "text-red-600 dark:text-red-400"}`}>{message.text}</div>;
    $[18] = message;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t2 || $[21] !== t8 || $[22] !== t9) {
    t10 = <div className="mt-4"><form onSubmit={t2} className="flex flex-col gap-2">{t3}{t8}{t9}</form></div>;
    $[20] = t2;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}